module.exports = __webpack_public_path__ + "static/media/usb-medellin.30b50bc0.png";